import { graphql } from "gql.tada";
import { LinkFragment } from "@queries/fragments/LinkFragment";
import { IconGridFragment } from "@queries/fragments/IconGridFragment";
import { RichEntryFragment } from "@queries/fragments/RichEntryFragment";

export const SolutionsRowFragment = graphql(
  /* GraphQL */ `
    fragment SolutionsRowFragment on SolutionsChapterRow {
      _id
      title
      eyebrow
      rowType
      collapsible
      ctaEvent
      ctaLink {
        ...LinkFragment
      }
      bodyRichText {
        ...RichEntryFragment
      }
    }
  `,
  [LinkFragment, RichEntryFragment]
);

export const SolutionsChapterFragment = graphql(
  /* GraphQL */ `
    fragment SolutionsChapterFragment on SolutionsChapter {
      _id
      title
      eyebrow
      menuLabel
      ctaEvent
      ctaLink {
        ...LinkFragment
      }
      media {
        url
        contentType
      }
      mediaSourceRichText {
        ...RichEntryFragment
      }
      mediaBodyRichText {
        ...RichEntryFragment
      }
      mediaHeading
      mediaLayout
      iconGrid {
        ...IconGridFragment
      }
      rowsCollection(limit: 10) {
        items {
          ...SolutionsRowFragment
        }
      }
    }
  `,
  [SolutionsRowFragment, IconGridFragment, RichEntryFragment, LinkFragment]
);

export const SolutionsSectionById = graphql(
  /* GraphQL */ `
    query SolutionsSectionById(
      $locale: String
      $preview: Boolean
      $id: String!
    ) {
      solutionsSection(id: $id, preview: $preview, locale: $locale) {
        _id
        title
        chaptersCollection(limit: 6) {
          items {
            ...SolutionsChapterFragment
          }
        }
      }
    }
  `,
  [SolutionsChapterFragment]
);
